// ticketManagementSlice.js

import { createSlice } from "@reduxjs/toolkit";

const ticketManagementSlice = (name, defaultSortField = "createdAt", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: (state) => Object.assign(state, initialState),
    },
  });

  return slice;
};

// Create each tab slice like tickets, ticketsDetail
export const ticketsSlice = ticketManagementSlice("tickets", "ticket_Name", "asc");
export const ticketsDetailSlice = ticketManagementSlice("ticketsDetail", "emp_Name", "asc");

// Export reducers together
export const manageTicketsReducers = {
  tickets: ticketsSlice.reducer,
  ticketsDetail: ticketsDetailSlice.reducer,
};
